import { ToastType } from "../context/ToastContext";
import { ToastContextType } from "../context/ToastContext";

let toastRef: ToastContextType | null = null;

export const setToastRef = (ref: ToastContextType) => {
  toastRef = ref;
};

export const showToast = (message: string, type: ToastType) => {
  toastRef?.showToast(message, type);
};

export const success = (message: string) => toastRef?.success(message);
export const err = (message: string) => toastRef?.err(message);
export const info = (message: string) => toastRef?.info(message);
export const warning = (message: string) => toastRef?.warning(message);